import { tidalColorsDark } from "./tidalColorsDark.js";
import { tidalColorsLight } from "./tidalColorsLight.js";
function createTidalColorPalettes() {
  return { tidalColorsDark, tidalColorsLight };
}
export {
  createTidalColorPalettes
};
//# sourceMappingURL=createTidalColorPalettes.js.map
